import { ArrowRight } from "lucide-react";

import { StatementList } from "./StatementList";

export type OfferingListProps = {
  items: readonly string[];
  ariaLabel?: string;
};

/** What a page offers, as scope statements rather than controls. */
export function OfferingList({ items, ariaLabel }: OfferingListProps) {
  return (
    <StatementList items={items} icon={ArrowRight} ariaLabel={ariaLabel} />
  );
}
